import React from 'react';
import camelcase from 'camelcase-es5';

import getSVGIconClassName from '../../utils/className/getSVGIconClassName';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import Box from '../Box/Box';
import { TIconProps } from './types';
import { colorMap } from './constants';

/**
 * Icon component that interfaces with the svg sprites
 */
const Icon = ({ name, color, className: externalClassName = '', ...rest }: TIconProps) => {
  const svgIconClassName = getSVGIconClassName(name);
  const className = `${externalClassName} ${svgIconClassName}`.trim();
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [color && camelcase(colorMap[color] || color)],
  });

  return (
    <Box {...rest} {...conditionalProps} name="Icon" as="i" aria-hidden="true" className={className} data-sem="Icon" />
  );
};

const MemoizedIcon = React.memo(Icon);
MemoizedIcon.displayName = 'Icon';

export default MemoizedIcon;
